import {useEffect, useState} from "react";
import {Button, Popconfirm, Space, Table} from "antd";
import {
    DownloadOutlined, LeftOutlined,
    RightOutlined,
    SearchOutlined,
    UsergroupAddOutlined, CheckCircleOutlined, ExclamationCircleOutlined, DeleteOutlined, CloseCircleOutlined
} from "@ant-design/icons";
import {useTranslation} from "react-i18next";
import Search from "antd/es/input/Search";
import {xcService} from "../../../../_services/xcService";
import localOrSessionStore from "../../../../_helpers/localOrSessionStore";
import variables from "../../../../_constants/variables";
import InviteUser from "./invite";
import {useDispatch, useSelector} from "react-redux";
import {authActions} from "../../../../_actions";

import { Excel } from "antd-table-saveas-excel";
import moment from "moment";

const CounselorsView = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const storage = localOrSessionStore({key: variables.REMEMBER});
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [sourceData, setSourceData] = useState([]);
    const [showInviteUserModal, setShowInviteUserModal] = useState(false);
    const [currentUser, setCurrentUser] = useState(false);
    const userType = storage.getItem(variables.USER_TYPE);
    const [userProfile, setUserProfile] = useState();
    const [actualPage, setActualPage] = useState(1)


    var actualYear = useSelector((state) => state.authReducer.actualYear);

    useEffect(()=>{
        if (!actualYear){
            dispatch(authActions.actualYear())

        }
    },[])

    function onlyUnique(value, index, self) {
        return self?.indexOf(value) === index;
    }


    const onSearch = ({target}) => {
        let mSearch = target.value.toLowerCase().normalize("NFD").replace(/\p{Diacritic}/gu, "")

        setTableData(mSearch === '' ? sourceData: sourceData.filter((item) => {
            return item.name.toLowerCase().normalize("NFD").replace(/\p{Diacritic}/gu, "").includes(mSearch)
                ||item.surname.toLowerCase().normalize("NFD").replace(/\p{Diacritic}/gu, "").includes(mSearch)
                ||item.email.toLowerCase().normalize("NFD").replace(/\p{Diacritic}/gu, "").includes(mSearch)
        }))
    }
    const columns = [
        {
            title: t("tutores.informes.tableselect"),
            dataIndex: 'name',
            render: (text) => <p className={"text-data"}>{text}</p>,
            sorter: (a, b) => a.name?.localeCompare(b.name)
        },
        {
            title: t("tutores.informes.tableemail"),
            dataIndex: 'email',
            render: (text) => <p className={"text-data text-data--small"}>{text}</p>,
            sorter: (a, b) => a.email?.localeCompare(b.email)

        },
        {
            title: t("tutores.informes.tabletelephone"),
            dataIndex: 'phone',
            render: (text) => <p className={"text-data text-data--small"}>{text}</p>,
            sorter: (a, b) => a.phone-b.phone
        },
        {
            title: t("tutores.informes.tablecenter"),
            dataIndex: 'centerName',
            render: (text) => <p className={"text-data text-data--small"}>{text}</p>,
            sorter: (a, b) => a.centre - b.centre
        },
        {
            title: t("tutores.informes.tablecode"),
            dataIndex: 'centerCode',
            render: (text) => <p className={"text-data text-data--small"}>{text}</p>,
            sorter: (a, b) => a.course?.localeCompare(b.centerCode),

            filters: userType === 'ADMIN' ? tableData.map(data => data.centerCode)
                .filter(onlyUnique)
                .sort((a, b) => a?.localeCompare(b))
                .map(centerCode => {
                    return {
                        text: centerCode,
                        value: centerCode
                    }
                }) : null,
            onFilter: (value, record) => {
                return record.centerCode?.indexOf(value) === 0
            },
        },

        {
            title: t("tutores.informes.tableyear"),
            dataIndex: 'year',
            render: (text) => <p className={"text-data text-data--small"}>{text}</p>,
            sorter: (a, b) => a.year?.localeCompare(b.year)

        },

        {
            title: t("tutores.informes.tablestate"),
            dataIndex: 'listNumber',
            render: (text, record) => {
                if (record.validated) {
                    return <div style={{fontSize: '11px', color: '#389E0D'}}><CheckCircleOutlined
                        style={{fontSize: '11px', fill: '#389E0D'}}/>{t("tutores.informes.validado")}</div>
                } else {
                    return <div style={{fontSize: '11px', color: '#FFB81C'}}><ExclamationCircleOutlined
                        style={{fontSize: '11px', fill: '#FFB81C'}}/>{t("tutores.informes.pendiente")}</div>
                }
            },
            sorter: (a, b) => a.state?.localeCompare(b.state),
            filters: tableData.map(data=>data.state)
                .filter(onlyUnique)
                .sort((a, b) => a?.localeCompare(b))
                .map(state=>{
                    return {
                        text: state,
                        value: state
                    }
                }),
            onFilter: (value, record) => {

                return record.state?.indexOf(value) === 0
            }
            ,
        },
        {
            title: t("tutores.informes.tableviewtuor"),
            key: 'view',
            render: (_, record) => (
                <Space size="middle">
                    <div className={"text-show-data"}><a onClick={()=>setCurrentUser(tableData.find(tutor=>tutor.email===record.email))}>{t("tutores.informes.view")} <RightOutlined /></a></div>
                </Space>
            ),
        },
    ];

    const getListado = () => {
        const tutorEndpoints = {
            'COUNSELOR': '/v1/counselor/tutors',
            'CENTER': '/v1/center/counselors',
            'MASTER': '/v1/master/counselors'
        }
        xcService.getToken(tutorEndpoints[userType])
            .then(({data})=>data.data.map(tutor=>{
                return {
                    ...tutor,
                    courseName: tutor.course?.name,
                    centerName: tutor.center?.name,
                    name: tutor.name + ' ' + tutor.surname,
                    year: tutor.year + '/' + (tutor.year+1)
                }
            }))
            .then(tutors=> {
                setSourceData(tutors)
                setTableData(tutors)
            })
    }
    useEffect(()=>{

        if (userType  !== 'MASTER')
        xcService.getToken(userType === 'CENTER' ? '/v1/center/me' : '/v1/tutor/me/center').then(({data}) => {
            setUserProfile(data.data)
        });

       getListado()
    },[])

    const onSelectChange = newSelectedRowKeys => {
        setSelectedRowKeys(newSelectedRowKeys);
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };

    const onChangePage = (pageNumber) => {
        setActualPage(pageNumber.current);
        localStorage.setItem("COUNSELORPAGE", pageNumber.current);
    };

    const goBack = () => {
        let mPage = 1;
        if (localStorage.getItem("COUNSELORPAGE")){
            mPage = +localStorage.getItem("COUNSELORPAGE")
        }
        setActualPage(mPage);
        setCurrentUser(null)

    }


    const deletetutor = (id) => {
        xcService.deleteToken(`/v1/master/tutors/${id}`).then(data => {
            getListado();
            setCurrentUser(null)
        })
    }


    const activateTutor = (id) => {
        xcService.putToken(`/v1/master/tutors/validate/${id}`).then(data => {
            getListado();
            setCurrentUser(null)
        })
    }


    const headersCsv = [
        { title: t("tutores.informes.tableename"), key: "name", dataIndex: "name" },
        { title: t("tutores.informes.tableemail"), key: "email", dataIndex: "email" },
        { title: t("tutores.informes.tabletelephone"), key: "phone", dataIndex: "phone" },
        { title: t("registro.nif"), key: "nif", dataIndex: "nif" },
        { title: t("registro.gender"), key: "gender", dataIndex: "gender" },
        { title: t("registro.profesion"), key: "profession", dataIndex: "profession" },
        { title: t("tutores.informes.tablecenter"), key: "centerName", dataIndex: "centerName" },
        { title: t("tutores.informes.tablecode"), key: "centerCode", dataIndex: "centerCode" }
    ];


    const exportXLS = () => {
        const excel = new Excel();
        excel
            .addSheet("counselors")
            .addColumns(headersCsv)
            .addDataSource(tableData, {
                str2Percent: true
            })
            .saveAs("counselorsExport" + moment().format(("YYYYMMDD")) + ".xlsx");
    }


    return (
        <>
            {showInviteUserModal &&
                <InviteUser t={t}  type={"counselor"}
                            link={"/tutorAuth/register"}
                            userProfile={userProfile} showInviteUserModal={showInviteUserModal} setShowInviteUserModal={setShowInviteUserModal} />
            }
            {!currentUser&&<div>
                <div className={"informes-header"}>
                    <div className={"informes-header__top"}>
                        <h1 className={"is-first"}>{t("orientadores.title")}</h1>
                        <Button className={"btnWhiteBlue"}
                                onClick={() => setShowInviteUserModal(true)}><UsergroupAddOutlined/>{t("alumnos.familyButton")}
                        </Button>
                    </div>

                        {userType === 'CENTER' &&
                            <>
                            <p>{t("lusers.centerorientador")}</p>
                            <p>{t("lusers.centersuborientador")}</p>
                            </>
                        }
                    {userType === 'MASTER' &&
                        <p>{t("tutores.informes.subtitlecounselors")}</p>
                    }

                    <div className={"informes-header__bottom"}>
                        <div className={"informes-header__bottom-left"}>
                            <Search
                                placeholder={t("tutores.informes.search")}
                                allowClear
                                enterButton={<SearchOutlined/>}
                                size="large"
                                onChange={onSearch}
                            />
                        </div>
                        <div className={"informes-header__bottom-right"}>
                                <Button  onClick={exportXLS} className={"btnWhiteBlue"}><DownloadOutlined/>{t("tutores.informes.downloadButton")}
                                </Button>

                        </div>
                    </div>
                </div>
                <div className={"report-table"}>
                    <Table rowKey={"id"}

                           onChange={onChangePage}
                           pagination={{current: actualPage, position: ['bottomCenter']}} rowSelection={rowSelection} columns={columns}
                           dataSource={tableData}/>
                </div>
            </div>}
            {currentUser&&<div>
                <div className={"informes-header"}>
                    <a className={"informes-header__back"} onClick={()=>goBack()}><LeftOutlined /> {t("backtolist")}</a>
                    <div className={"informes-header__top"}>
                        <h1>{t("tutores.orientador.title")}</h1>
                    </div>
                    <div className={"cardStudent cardStudent--max-width"}>

                        <div className={"itemCard itemCardHeader"}>{t("informes.card.title")}</div>
                        <div className={"itemCard"}><div className={"itemCardLeft"}>{t("tutores.informes.tableename")}:</div><div className={"itemCardRight"}>{currentUser.name}</div></div>
                        <div className={"itemCard"}><div className={"itemCardLeft"}>{t("tutores.informes.tableemail")}:</div><div className={"itemCardRight"}>{currentUser.email}</div></div>
                        <div className={"itemCard"}><div className={"itemCardLeft"}>{t("tutores.informes.tablenif")}:</div><div className={"itemCardRight"}>{currentUser.nif}</div></div>
                        <div className={"itemCard"}><div className={"itemCardLeft"}>{t("tutores.informes.tabledegree")}:</div><div className={"itemCardRight"}>{currentUser.profession}</div></div>
                        <div className={"itemCard"}><div className={"itemCardLeft"}>{t("tutores.informes.tablecenter")}:</div><div className={"itemCardRight"}>{currentUser.centerName.replaceAll("&quot;","")}</div></div>
                        <div className={"itemCard"}><div className={"itemCardLeft"}>{t("tutores.informes.tabledirector")}:</div><div className={"itemCardRight"}>{currentUser.center?.directorName } {currentUser.center?.directorSurname}</div></div>
                        <div className={"itemCard"}><div className={"itemCardLeft"}>{t("tutores.informes.tablecode")}:</div><div className={"itemCardRight"}>{currentUser.centerCode}</div></div>
                        <div className={"itemCard"}><div className={"itemCardLeft"}>{t("tutores.informes.tableyear")}:</div><div className={"itemCardRight"}>20{(
                            actualYear ?
                                (+actualYear) : 22)+'/20'+(actualYear ?
                            (+actualYear +1): 23)}</div></div>

                    </div>

                        {currentUser.validated ?
                            <>
                            <Popconfirm  onConfirm={() => deletetutor(currentUser.id)}
                                         title={t("estaseguro")}
                                         okText={t("yes")}
                                         cancelText="No"
                            >
                                <Button className={"btnWhiteBlue"}><DeleteOutlined />{t("tutores.alumno.unlink")}</Button></Popconfirm>
                            </>
                            :<div style={{display: "flex", flexDirection: "row"}}>
                            <Button onClick={() => activateTutor(currentUser.id)} className={"btnWhiteBlue"}><CheckCircleOutlined />{t("tutores.tutor.validate")}</Button>&nbsp;&nbsp;

                                <Popconfirm  onConfirm={() => deletetutor(currentUser.id)}
                                             title={t("estaseguro")}
                                             okText={t("yes")}
                                             cancelText="No"
                                ><Button className={"btnWhiteBlue"}><CloseCircleOutlined />{t("tutores.tutor.reject")}</Button></Popconfirm>
                                </div>}

                </div>
            </div>}
        </>
    )
}

export default CounselorsView;
